var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-art-likes"},[_c('CommonHeader',[_vm._v(_vm._s(_vm.$t('article.list.like')))]),_c('main',[_c('JoLoadMore',{ref:"loadmore",attrs:{"auto-load":false},on:{"onRefresh":_vm.onRefresh,"onLoadMore":_vm.onLoadMore}},_vm._l((_vm.likes),function(ref,index){
var user = ref.user;
var id = ref.id;
return _c('UserItem',{key:("likes-" + id + "-" + (user.id) + "-" + index),attrs:{"user":user}})}),1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }